import { AxiosError } from "axios";
import { pushGlobalError } from "./globalError";
import { localizeApiMessage } from "./messages";

export type ErrorResponse = {
  message?: string;
  error?: string;
  detail?: string;
};

export function handleAxiosError(error: AxiosError<ErrorResponse>) {
  let msg = "Unknown error occurred";

  // Per-request override (e.g. blob responses whose error body can't be read here).
  const meta = error.config?.meta;
  const status = error.response?.status;
  const override =
    (status ? meta?.errorMsgByStatus?.[status] : undefined) ?? meta?.errorMsg;
  if (override) {
    pushGlobalError(override);
    return;
  }

  if (error.response) {
    const data = error.response.data;
    msg = localizeApiMessage(
      data.message ||
        data.error ||
        data.detail ||
        `Error ${error.response.status}: ${error.response.statusText}`,
    );
  } else if (error.request) {
    msg = "No response from server. Please check your network.";
  } else if (error.message) {
    msg = error.message;
  }

  pushGlobalError(msg);
}
